<div class="invoice-list-wrapper">
  <!-- Supplier view -->
  <app-supplier-invoices-list *ngIf="isSupplier"></app-supplier-invoices-list>

  <!-- Buyer view -->
  <app-buyer-invoices-list *ngIf="isBuyer"></app-buyer-invoices-list>
</div>
